import { useEffect, useRef, useState } from "react";

const INTERACTIVE_SELECTOR =
  'a, button, [role="button"], input, textarea, select, label, .MuiButton-root, .MuiIconButton-root, .MuiListItem-button, [data-cursor-hover]';

export const CustomCursor = () => {
  const cursorRef = useRef(null);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!window.matchMedia || !window.matchMedia("(pointer: fine)").matches) {
      return;
    }
    setEnabled(true);
  }, []);

  useEffect(() => {
    if (!enabled) return;
    const cursor = cursorRef.current;
    if (!cursor) return;

    const evaluateAt = (x, y) => {
      const el = document.elementFromPoint(x, y);
      if (el && el.closest && el.closest(INTERACTIVE_SELECTOR)) {
        cursor.classList.add("aw-cursor-active");
      } else {
        cursor.classList.remove("aw-cursor-active");
      }
    };

    const onMove = (e) => {
      cursor.style.transform = `translate(${e.clientX}px, ${e.clientY}px) translate(-50%, -50%)`;
      evaluateAt(e.clientX, e.clientY);
    };

    const onMouseDown = () => cursor.classList.add("aw-cursor-clicking");
    const onMouseUp = () => cursor.classList.remove("aw-cursor-clicking");

    const onClick = () => {
      // Navigation often happens on click; clear stale states so the next mousemove re-evaluates cleanly.
      cursor.classList.remove("aw-cursor-active", "aw-cursor-clicking");
    };

    const onLeaveWindow = () => cursor.classList.add("aw-cursor-hidden");
    const onEnterWindow = () => cursor.classList.remove("aw-cursor-hidden");

    document.addEventListener("mousemove", onMove);
    document.addEventListener("mousedown", onMouseDown);
    document.addEventListener("mouseup", onMouseUp);
    document.addEventListener("click", onClick);
    document.documentElement.addEventListener("mouseleave", onLeaveWindow);
    document.documentElement.addEventListener("mouseenter", onEnterWindow);

    return () => {
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mousedown", onMouseDown);
      document.removeEventListener("mouseup", onMouseUp);
      document.removeEventListener("click", onClick);
      document.documentElement.removeEventListener("mouseleave", onLeaveWindow);
      document.documentElement.removeEventListener("mouseenter", onEnterWindow);
    };
  }, [enabled]);

  if (!enabled) return null;

  return <div ref={cursorRef} className="aw-cursor aw-cursor-hidden" />;
};
